/* eslint-disable camelcase */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import { signInSocialAction } from 'Store/modules/auth/actions';
import { searchSelector } from 'Store/modules/router/selectors';
import View from './view';

const SignUpStepOne = (): JSX.Element => {
  const dispatch = useDispatch();
  const search = useSelector(searchSelector);
  const params = queryString.parse(search);

  const onSignInSocial = (provider: string): void => {
    dispatch(signInSocialAction(provider));
  };

  useEffect(() => {
    const { social_provider } = params;
    if (social_provider) {
      onSignInSocial(social_provider as string);
    }
  }, []);

  return <View onSignInSocial={onSignInSocial} />;
};

export default SignUpStepOne;
